import { OreStack } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { AdvertisementModel } from '@/Home/domain'
import { AdvertisementModule } from '@/Home/ui/atoms'
import { homeTranslation } from '@/Home/ui/homeTranslation'
import { WebTagPermissionEnum } from '@/Shared/domain'
import webMerchantsClubEdenred from '@/Shared/ui/assets/web_merchants_Club_Edenred.png'
import webMerchantsPremiumEdenred from '@/Shared/ui/assets/web_merchants_Edenred_Premium.png'
import webMerchantsFood from '@/Shared/ui/assets/web_merchants_FOOD.png'
import { navigationRoutes } from '@/Shared/ui/routers'
import { useUserData } from '@/User/ui/context'

export const AdvertisingSpace = (props: {
  hasPermission: (tag: string) => boolean
}): JSX.Element => {
  const { t } = useTranslation()
  const { merchant, hirableInfo } = useUserData()
  const hideAd01ForProductCode = (merchant?.products || []).some(
    product => product.productCode === 33,
  )

  const AdvertisementModules: AdvertisementModel[] = [
    ...(hideAd01ForProductCode ||
    (!hirableInfo.canBeHiredOnline && !hideAd01ForProductCode)
      ? []
      : [
          {
            id: 'ad-01',
            title: t(homeTranslation.advertisementSpace.modules.module1Premium.title),
            image: webMerchantsPremiumEdenred,
            link: navigationRoutes.contractNewProducts,
            cta: t(homeTranslation.advertisementSpace.modules.module1Premium.cta),
            description: t(
              homeTranslation.advertisementSpace.modules.module1Premium.description,
            ),
          },
        ]),
    {
      id: 'ad-02',
      title: t(homeTranslation.advertisementSpace.modules.module2.title),
      image: webMerchantsClubEdenred,
      link: import.meta.env.VITE_WEB_MERCHANTS_CLUB_EDENRED_LINK,
      cta: t(homeTranslation.advertisementSpace.modules.module2.cta),
      description: t(homeTranslation.advertisementSpace.modules.module2.description),
    },
    {
      id: 'ad-03',
      title: t(homeTranslation.advertisementSpace.modules.module3.title),
      image: webMerchantsFood,
      link: import.meta.env.VITE_WEB_MERCHANTS_FOOD_LINK,
      cta: t(homeTranslation.advertisementSpace.modules.module3.cta),
      description: t(homeTranslation.advertisementSpace.modules.module3.description),
    },
  ]
  return (
    <OreStack direction="row" space="large">
      {AdvertisementModules.map(advertisement => {
        if (
          advertisement.id === 'ad-01' &&
          !props.hasPermission(WebTagPermissionEnum.ACTION_CONTRACT_NEW_PRODUCTS)
        ) {
          return null
        }
        return (
          <AdvertisementModule key={advertisement.id} advertisement={advertisement} />
        )
      })}
    </OreStack>
  )
}
